{
  "name": "client",
  "version": "1.5.4",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "build:UAT": "ng build --base-href / --configuration=uat",
    "build:PROD": "ng build --base-href / --configuration=production",
    "test": "ng test",
    "lint": "ng lint",
    "e2e": "ng e2e"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^22.2.3",
    "@angular/cdk": "^22.2.3",
    "@angular/common": "^22.2.3",
    "@angular/compiler": "^22.2.3",
    "@angular/core": "^22.2.3",
    "@angular/forms": "^22.2.3",
    "@angular/material": "^22.2.3",
    "@angular/material-moment-adapter": "^22.2.3",
    "@angular/platform-browser": "^22.2.3",
    "@angular/platform-browser-dynamic": "^22.2.3",
    "@angular/router": "^22.2.3",
    "@automapper/classes": "^8.7.7",
    "@automapper/core": "^8.7.7",
    "@gerandon/ngx-material-timepicker": "^22.0.0",
    "@js-temporal/polyfill": "^0.5.1",
    "@types/luxon": "^3.7.6",
    "angular-calendar": "^0.32.2",
    "angular-draggable-droppable": "^9.0.1",
    "angular-resizable-element": "^8.0.0",
    "bootstrap": "^5.2.3",
    "date-fns": "^4.0.0",
    "detect-browser": "^5.2.0",
    "js-sha512": "^0.8.0",
    "jwt-decode": "^3.1.2",
    "lodash": "^4.17.21",
    "luxon": "^3.4.4",
    "moment": "^2.29.4",
    "ng-circle-progress": "^1.7.1",
    "rxjs": "~6.5.4",
    "tslib": "^2.0.0",
    "turbocommons-ts": "^3.8.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^22.2.3",
    "@angular/cli": "^22.2.3",
    "@angular/compiler-cli": "^22.2.3",
    "@angular/language-service": "^22.2.3",
    "@eslint/js": "^10.0.1",
    "@types/jasmine": "^3.7.1",
    "@types/jasminewd2": "~2.0.3",
    "@types/lodash": "^4.14.171",
    "@types/node": "^12.11.1",
    "angular-eslint": "22.6.0",
    "eslint": "^10.12.0",
    "istanbul-lib-instrument": "^6.0.3",
    "jasmine-core": "^3.7.1",
    "jasmine-spec-reporter": "~5.0.0",
    "karma": "~6.4.2",
    "karma-chrome-launcher": "~3.1.0",
    "karma-coverage-istanbul-reporter": "~3.0.2",
    "karma-jasmine": "~4.0.0",
    "karma-jasmine-html-reporter": "^1.5.0",
    "protractor": "~7.0.0",
    "ts-node": "~8.3.0",
    "typescript": "~6.0.3",
    "typescript-eslint": "8.71.0"
  }
}
